import { Lightning, Utils, Log, Router, Img } from '@lightningjs/sdk';
import { SelectScreenInfo } from '../../../app-api-config';
import { Column, Row } from '@lightningjs/ui-components';
import TwoRowThumb from './TwoRowThumb';


export default class TwoRowScreenTile extends Lightning.Component {
    SelectScreenInfo: SelectScreenInfo | undefined
    
    static override _template() {
        return {
            w: 1920,
            h: 1080,
            clipping: true, 
            Wrapper: {
                w: (w) => w,
                h: (h) => h*2,
                type: Column,
                collision:true,
                plinko: true,
                clipping: true, 
                items: [],
                style: {
                    itemSpacing	: 0
                }
            },

        }
    }

    override _init(): void {
        this.tag('Wrapper')._Items.collision=true
    }

    override _firstActive() {
        const selectScreenInfo = this.selectScreenInfo
        const selectOptions = this.combinedRows || [];

        const items = selectOptions.map((row, rowIndex) => {
            return {
                type: Row,
                collision:true,
                autoResizeHeight: true,
                // wrapSelected: true,
                style: {
                    itemSpacing	: 0
                },
                items: row.map((item, itemIndex) => ({
                    w: parseInt(selectScreenInfo?.optimgw),
                    h: parseInt(selectScreenInfo?.optimgh),
                    type: TwoRowThumb,
                    imgSrc: item.img,
                    selectedImgSrc: item.imgSelect,
                    rowIndex,
                    itemIndex,
                    collision:true,
                    blockItem: item.blockItem
                }))                
            };
        });

        this.patch({ Wrapper: { items: items } });
    }

    override _getFocused(){
        return this.tag('Wrapper')
    }

    // _handleClick(e) {
    //     console.log('2 row select screen Title: _handle click: ', e)
    //     return false
    // }
    

}
